module.exports = __webpack_public_path__ + "static/media/review3.cecf6b00.mp4";